import {
    Directive,
    EmbeddedViewRef,
    Input,
    OnDestroy,
    OnInit,
    TemplateRef,
    ViewContainerRef,
} from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from '../../../core/auth/auth.service';
import { Iri } from '../../../core/dto/iri';
import { canEditPerson } from './person-auth';

@UntilDestroy()
@Directive({
    selector: '[isavCanEditPerson]',
})
export class CanEditPerson implements OnInit, OnDestroy {
    @Input('isavCanEditPerson') personUnderEditIri: Iri;
    @Input('isavCanEditPersonContext') context: any;

    private mountedView: EmbeddedViewRef<any> | null;

    constructor(
        private authService: AuthService,
        private templateRef: TemplateRef<any>,
        private vcRef: ViewContainerRef
    ) {}

    ngOnInit(): void {
        combineLatest([
            this.authService.authenticated$(),
            this.authService.roles$(),
            this.authService.userIri$(),
        ])
            .pipe(
                untilDestroyed(this),
                map(
                    ([authenticated, roles, userIri]) =>
                        authenticated && canEditPerson(this.personUnderEditIri, userIri, roles)
                )
            )
            .subscribe((mount: boolean) => {
                if (mount) {
                    this.create();
                } else {
                    this.destroy();
                }
            });
    }

    ngOnDestroy(): void {
        this.destroy();
    }

    private create(): void {
        if (this.mountedView) return;
        this.mountedView = this.vcRef.createEmbeddedView(this.templateRef, this.context);
    }

    private destroy(): void {
        if (!this.mountedView) return;

        this.vcRef.clear();
        this.mountedView = null;
    }
}
